
    import '/opt/buildhome/repo/packages/x/docs/x-markdown/plugin-highlightcode.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-markdown-plugin-highlightcode-demo-basic","docs-x-markdown-plugin-highlightcode-demo-streaming","docs-x-markdown-plugin-highlightcode-demo-_semantic"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-markdown/plugin-highlightcode.zh-CN.md?type=demo')
};